export default __webpack_public_path__ + "3a1eecef5b70feb91e9f4a57021918b3.png";